import { useMemo } from "react";
import { Estacionamiento } from "../../../types/Estacionamiento";

interface UseFilteredEstacionamientosProps {
  estacionamientos: Estacionamiento[];
  loading: boolean;
  error: string | null;
}

export const useFilteredEstacionamientos = ({
  estacionamientos,
  loading,
  error,
}: UseFilteredEstacionamientosProps) => {
  return useMemo(() => {
    if (loading || error) {
      return [];
    }

    // Filtrar solo estacionamientos activos y ordenar por nombre
    return estacionamientos
      .filter((est) => est.activo)
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
  }, [estacionamientos, loading, error]);
};
